class PartFinder extends HTMLElement {
  constructor() {
    super();
    this.partFinderHolder = this.querySelector(".holder");
    this.errorText = this.querySelector(".error-text");

    var product_page = window.parts_finder ? true : false;
    this.initPartFinder([], product_page);
  }

  handleize(str) {
    str = str
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "") // Remove accents
      .replace(/([^\w]+|\s+)/g, "-") // Replace space and other characters by hyphen
      .replace(/\-\-+/g, "-") // Replaces multiple hyphens by one hyphen
      .replace(/(^-+|-+$)/g, "") // Remove extra hyphens from beginning or end of the string
      .toLowerCase(); // To lowercase
    return str;
  }

  isOptionValueExists(selectElement, targetValue) {
    for (let i = 0; i < selectElement.options.length; i++) {
      if (selectElement.options[i].value === targetValue) {
        return true; // Option value exists
      }
    }
    return false; // Option value does not exist
  }

  async initPartFinder(searchParams, product_page) {
    this.partFinderHolder.classList.add("loading");

    var part_finder_html = await this.getPartFinder(searchParams);
    var html = await part_finder_html.text().then(async (html) => {
      return html;
    });

    var myDiv = document.createElement("div");
    myDiv.innerHTML = html;
    this.partFinderHolder.innerHTML = myDiv.innerHTML;

    this.partFinderHolder.classList.remove("loading");

    console.log("window.parts_finder");

    if (product_page) {
      if (window.parts_finder.Make != "") {
        var option_exists = this.isOptionValueExists(
          this.partFinderHolder.querySelector('.select-dropdown[name="Make"]'),
          "filter.p.m.custom.make=" + window.parts_finder.Make
        );
        if (option_exists) {
          this.partFinderHolder.querySelector(
            '.select-dropdown[name="Make"]'
          ).value = "filter.p.m.custom.make=" + window.parts_finder.Make;
        } else {
          var option = document.createElement("option");
          option.value = "filter.p.m.custom.make=" + window.parts_finder.Make;
          option.text = window.parts_finder.Make;
          this.partFinderHolder
            .querySelector('.select-dropdown[name="Make"]')
            .add(option);
          this.partFinderHolder.querySelector(
            '.select-dropdown[name="Make"]'
          ).value = "filter.p.m.custom.make=" + window.parts_finder.Make;
        }
      }
      if (window.parts_finder.Model != "") {
        var option_exists = this.isOptionValueExists(
          this.partFinderHolder.querySelector('.select-dropdown[name="Model"]'),
          "filter.p.m.custom.model=" + window.parts_finder.Model
        );
        if (option_exists) {
          this.partFinderHolder.querySelector(
            '.select-dropdown[name="Model"]'
          ).value = "filter.p.m.custom.model=" + window.parts_finder.Model;
        } else {
          var option = document.createElement("option");
          option.value = "filter.p.m.custom.model=" + window.parts_finder.Model;
          option.text = window.parts_finder.Model;
          this.partFinderHolder
            .querySelector('.select-dropdown[name="Model"]')
            .add(option);
          this.partFinderHolder.querySelector(
            '.select-dropdown[name="Model"]'
          ).value = "filter.p.m.custom.model=" + window.parts_finder.Model;
        }
      }
      if (window.parts_finder.Product_Type != "") {
        // Check if the option exists in the "Part Type" dropdown
        var option_exists = this.isOptionValueExists(
          this.partFinderHolder.querySelector(
            '.select-dropdown[name="Part Type"]'
          ),
          "filter.p.product_type=" +
            window.parts_finder.Product_Type.replace(" ", "+")
        );
        if (option_exists) {
          // Set the dropdown's value if the option exists
          this.partFinderHolder.querySelector(
            '.select-dropdown[name="Part Type"]'
          ).value =
            "filter.p.product_type=" +
            window.parts_finder.Product_Type.replace(" ", "+");
        } else {
          // Create a new option and add it to the dropdown if the option doesn't exist
          var option = document.createElement("option");
          option.value =
            "filter.p.product_type=" +
            window.parts_finder.Product_Type.replace(" ", "+");
          option.text = window.parts_finder.Product_Type;
          this.partFinderHolder
            .querySelector('.select-dropdown[name="Part Type"]')
            .add(option);
          this.partFinderHolder.querySelector(
            '.select-dropdown[name="Part Type"]'
          ).value =
            "filter.p.product_type=" +
            window.parts_finder.Product_Type.replace(" ", "+");
        }
      }
      if (window.parts_finder.Year != "") {
        // Check if the option exists in the "Year" dropdown
        var option_exists = this.isOptionValueExists(
          this.partFinderHolder.querySelector('.select-dropdown[name="Year"]'),
          "filter.p.m.custom.year=" + window.parts_finder.Year
        );
        if (option_exists) {
          // Set the dropdown's value if the option exists
          this.partFinderHolder.querySelector(
            '.select-dropdown[name="Year"]'
          ).value = "filter.p.m.custom.year=" + window.parts_finder.Year;
        } else {
          // Create a new option and add it to the "Year" dropdown if the option doesn't exist
          var option = document.createElement("option");
          option.value = "filter.p.m.custom.year=" + window.parts_finder.Year;
          option.text = window.parts_finder.Year;
          this.partFinderHolder
            .querySelector('.select-dropdown[name="Year"]')
            .add(option);
          this.partFinderHolder.querySelector(
            '.select-dropdown[name="Year"]'
          ).value = "filter.p.m.custom.year=" + window.parts_finder.Year;
        }
      }
    }

    this.submitButton = this.partFinderHolder.querySelector(".search-btn");
    // Lets assign change events to all selects
    this.selects = this.partFinderHolder.querySelectorAll("select");

    if (this.selects.length > 0) {
      this.selects.forEach((select) => {
        select.addEventListener(
          "change",
          this.selectChange.bind(this, product_page)
        );
      });
    }

    this.updateButton();
  }

  updateButton(product_page) {
    var filters = ["sort_by=best-selling"];
    var make = "all";

    this.selects.forEach((select) => {
      if (select.value !== "none") filters.push(select.value);
      if (select.value.includes("custom.make"))
        make = this.handleize(select.value.split("=")[1]);
      if (select.value.includes("p.product_type"))
        make = this.handleize(select.value.split("=")[1]);
    });

    var searchParams = filters.join("&");
    this.submitButton.href = "/collections/" + make + "/?" + searchParams;

    return searchParams;
  }

  selectChange(product_page, e) {
    if (product_page) {
      this.selects.forEach((select) => {
        if (select !== e.target) {
          select.selectedIndex = 0;
        }
      });
    }

    var searchParams = this.updateButton();
    this.initPartFinder(searchParams, false);
  }

  async getCollectionJson(handle) {
    return fetch(`/collections/${handle}.json`).then(async (response) => {
      var json = await response.json();

      console.log("json", json);

      return {
        status: response.status,
        collection: json.collection,
      };
    });
  }

  async asyncForEach(array, callback) {
    for (let index = 0; index < array.length; index++) {
      await callback(array[index], index, array);
    }
  }

  async getPartFinder(searchParams) {
    console.log("searchParams", searchParams);

    var collection_name = "all";

    if (searchParams.length > 0) {
      await this.asyncForEach(searchParams.split("&"), async (param) => {
        if (param.includes("custom.make") || param.includes("p.product_type")) {
          var collection_handle = this.handleize(param.split("=")[1]);
          var does_collection_exist = await this.getCollectionJson(
            collection_handle
          );

          if (
            does_collection_exist.status !== 404 &&
            does_collection_exist.collection &&
            does_collection_exist.collection.products_count > 0
          ) {
            collection_name = this.handleize(param.split("=")[1]);
          }
        }
      });
    }

    var parts_finder_url =
      `/collections/${collection_name}?view=parts-finder&${searchParams}&timestamp=`.concat(
        Date.now()
      );

    console.log("parts_finder_url TESTING", parts_finder_url);

    return fetch(parts_finder_url, {
      credentials: "same-origin",
      method: "GET",
    })
      .then(async (content) => {
        if (content.status === 404) {
          this.partFinderHolder.classList.remove("loading");
          this.errorText.innerHTML =
            '<span class="alert">Collection Not found</span>';
          return;
        }

        return content;
      })
      .catch((e) => {
        console.error(e);
      });
  }
}

customElements.define("part-finder", PartFinder);

class HeaderMenuParts extends HTMLElement {
  constructor() {
    super();
    this.menuItems = this.querySelectorAll("header-menu");
    if (this.menuItems.length > 0) this.getMenus();

    let items = document
      .querySelector(".header__inline-menu")
      .querySelectorAll("details");

    items.forEach((item) => {
      item.addEventListener("mouseover", () => {
        item.setAttribute("open", true);
        item.querySelector("ul").addEventListener("mouseleave", () => {
          item.removeAttribute("open");
        });
        item.addEventListener("mouseleave", () => {
          item.removeAttribute("open");
        });
      });

      item.addEventListener("click", async (e) => {
        var part = e.target.closest(".part-name");
        var part_handle = part.dataset.partHandle;

        var collection_query = "all";
        var part_collection = await this.getCollectionJson(part_handle);
        if (part_collection === 200) {
          collection_query = part_handle;
        }

        window.location.href =
          window.shopUrl +
          `/collections/${collection_query}?filter.p.product_type=${part.dataset.partName}&sort_by=best-selling`;
      });
    });
  }

  async getMenus() {
    await this.asyncForEach(this.menuItems, async (menu, i) => {
      var name = menu.querySelector(".part-name").dataset.partName;
      var part_handle = menu.querySelector(".part-name").dataset.partHandle;

      var part_finder_html = await this.getMenuItem(name, part_handle);
      var html = await part_finder_html.text().then(async (html) => {
        return html;
      });
      var holder = menu.querySelector(".mega-menu__content");

      holder.innerHTML = html;
    });
  }

  async asyncForEach(array, callback) {
    for (let index = 0; index < array.length; index++) {
      await callback(array[index], index, array);
    }
  }

  async getCollectionJson(handle) {
    return fetch(`/collections/${handle}.json`).then((response) => {
      return response.status;
    });
  }

  async getMenuItem(name, part_handle) {
    var collection_query = "all";
    var part_collection = await this.getCollectionJson(part_handle);
    if (part_collection === 200) {
      collection_query = part_handle;
    }

    var parts_finder_url =
      `/collections/${collection_query}?view=menu-item&sort_by=best-selling&filter.p.product_type=${name}&filter.v.price.gte=&filter.v.price.lte=&timestamp=`.concat(
        Date.now()
      );

    return fetch(parts_finder_url, {
      credentials: "same-origin",
      method: "GET",
    }).then(async (content) => {
      return content;
    });
  }
}

customElements.define("header-menu-parts", HeaderMenuParts);

class CollectionDescription extends HTMLElement {
  constructor() {
    super();

    var content_area =
      this.querySelector(".content_area") ||
      this.querySelector(".metafield-rich_text_field");
    const childNodes = content_area.childNodes;

    // Create a new div element
    const hiddenDiv = document.createElement("div");
    hiddenDiv.classList.add("extra-content");
    hiddenDiv.style.display = "none";

    let shouldMove = false;
    let elementCount = 0;

    // Loop through child nodes
    for (let i = 0; i < childNodes.length; i++) {
      if (childNodes[i].nodeType !== Node.ELEMENT_NODE) {
        continue; // Skip text nodes
      }

      elementCount++;
      if (shouldMove) {
        // Clone the child node and append it to the hidden div
        hiddenDiv.appendChild(childNodes[i].cloneNode(true));
        // Remove the original child node
        content_area.removeChild(childNodes[i]);
        // Decrement the counter since we removed a node
        i--;
      }
      // Check if we have moved past the first two element nodes
      if (!shouldMove && elementCount > 0) {
        shouldMove = true;
      }
    }

    // Append the hidden div after the content area
    content_area.parentNode.insertBefore(hiddenDiv, content_area.nextSibling);

    var read_more = this.querySelector(".read-more");
    if (read_more) {
      // Hide the read more link if hiddenDiv is empty
      if (hiddenDiv.textContent.trim() === "") {
        read_more.style.display = "none";
      }

      read_more.addEventListener("click", (event) => {
        // Toggle display of the hidden div
        if (hiddenDiv.style.display === "none") {
          hiddenDiv.style.display = "block";
          read_more.textContent = "Read Less";
        } else {
          hiddenDiv.style.display = "none";
          read_more.textContent = "Read More";
        }
      });
    }
  }
}
customElements.define("collection-description", CollectionDescription);
